var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPillar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 150 150",
    id: "pillar",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#edebf2",
    d: "M97.281,41.516H52.719a3.417,3.417,0,1,0,0,6.833H97.281a3.417,3.417,0,1,0,0-6.833Z",
    className: "colorebeff2 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#48259d",
    d: "M102.558,48.349l-.1.005v-.005H47.639v.01l-.2-.01a8.657,8.657,0,1,0,8.425,6.757H94.133a8.634,8.634,0,1,0,8.425-6.757Z",
    className: "colore0e5e9 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#edebf2",
    d: "M102.6,51.315a5.643,5.643,0,1,0,5.642,5.642A5.642,5.642,0,0,0,102.6,51.315Z",
    className: "colorebeff2 svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#48259d",
    d: "M102.6,54.44a2.518,2.518,0,1,0,2.517,2.517A2.517,2.517,0,0,0,102.6,54.44Z",
    className: "colore0e5e9 svgShape"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#edebf2",
    d: "M47.353,51.315A5.643,5.643,0,1,0,53,56.957,5.642,5.642,0,0,0,47.353,51.315Z",
    className: "colorebeff2 svgShape"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#48259d",
    d: "M47.353,54.44a2.518,2.518,0,1,0,2.518,2.517A2.517,2.517,0,0,0,47.353,54.44Z",
    className: "colore0e5e9 svgShape"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38.354,
    height: 54.472,
    x: 55.823,
    y: 54.013,
    fill: "#edebf2",
    className: "colorebeff2 svgShape"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.309,
    height: 49.01,
    x: 61.083,
    y: 59.475,
    fill: "#48259d",
    className: "colore0e5e9 svgShape"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3.31,
    height: 49.01,
    x: 69.258,
    y: 59.475,
    fill: "#48259d",
    className: "colore0e5e9 svgShape"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3.31,
    height: 49.01,
    x: 77.433,
    y: 59.475,
    fill: "#48259d",
    className: "colore0e5e9 svgShape"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 3.309,
    height: 49.01,
    x: 85.608,
    y: 59.475,
    fill: "#48259d",
    className: "colore0e5e9 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillar);
export default __webpack_public_path__ + "static/media/pillar.a771188c9216796701c749f08533de1b.svg";
export { ForwardRef as ReactComponent };